import { render, staticRenderFns } from "./BlogSearchResult.vue?vue&type=template&id=4a869de8&"
import script from "./BlogSearchResult.vue?vue&type=script&lang=js&"
export * from "./BlogSearchResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports